const CountBy = Object.freeze({
  DOCUMENT: 'DOCUMENT',
  SENTENCE: 'SENTENCE'
})
export default CountBy
// RESERVE BELOW
